import React from "react"

// No apps discovered yet — apps appear automatically once the sync engine sees
// a transaction, so the CTA points the partner at the connection settings.
export function EmptyState({ copy, settingsPath }) {
  return (
    <div className="rounded-xl border border-indigo-200 dark:border-indigo-900/50 bg-indigo-50 dark:bg-indigo-950/40 p-6 text-center">
      <p className="font-semibold text-gray-900 dark:text-gray-100">{copy.empty.title}</p>
      <p className="mx-auto mt-1 max-w-md text-sm text-gray-600 dark:text-gray-400">{copy.empty.body}</p>
      <button
        type="button"
        onClick={() => {
          window.location.href = settingsPath
        }}
        className="mt-4 inline-flex rounded-lg bg-brand-600 px-5 py-2.5 text-sm font-semibold text-white hover:bg-brand-700 active:scale-95 transition-all"
      >
        {copy.empty.cta}
      </button>
    </div>
  )
}
